/**
 * Schema MySQL do tenant: usa xprobase.dominios.bd quando preenchido;
 * caso contrário infere de host `subdominio.xpro.me` (mesma regra da API / console).
 *
 * @param {string | null | undefined} dominioRaw host ou URL do workspace (ex.: piracanjuba.xpro.me)
 * @param {string | null | undefined} bdRaw valor da coluna bd
 * @returns {string} slug do schema ou string vazia se não for possível resolver
 */
export function resolveTenantDatabaseName(dominioRaw, bdRaw) {
  const trimmed = String(bdRaw || "").trim();
  if (trimmed) return trimmed;
  const dom = String(dominioRaw || "").trim().toLowerCase();
  if (!dom) return "";
  const host = dom.replace(/^https?:\/\//i, "").split("/")[0].split(":")[0];
  if (!host || !host.endsWith(".xpro.me")) return "";
  const schema = host.slice(0, -".xpro.me".length);
  if (!schema || schema.includes(".")) return "";
  return schema;
}
